import { render, staticRenderFns } from "./SingleProccess.vue?vue&type=template&id=8a18e338&"
import script from "./SingleProccess.vue?vue&type=script&lang=js&"
export * from "./SingleProccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports